import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isSidebarOpen: false, // Initial sidebar state
};

const sidebarSlice = createSlice({
  name: "sidebar",
  initialState,
  reducers: {
    toggleSidebar: (state) => {
      state.isSidebarOpen = !state.isSidebarOpen;
    },
  },
});

// Export the action and selector
export const { toggleSidebar } = sidebarSlice.actions;
export const selectIsSidebarOpen = (state) => state.sidebar.isSidebarOpen;

// Export the reducer
export default sidebarSlice.reducer;
